import React from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { CamerasParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';
import CameraPlayerComponent from './CameraPlayerComponent';

interface EventDetailParams {
    navigation: RootNavigation;
}

export default function CameraMapPlayer({ navigation }: EventDetailParams) {
    const route = useRoute<RouteProp<CamerasParamList, 'CameraMapPlayer'>>();
    return <CameraPlayerComponent navigation={navigation} route={route} page={'map'} />;
}
